export default __webpack_public_path__ + "static/media/wheels.20f12119.png";